<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('serialProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('serialProfile.pageTitle'),
            href: '/admin/product-profiles'
          },
          {
            text: $t('productProfile.ViewAllSerial'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6 text-end">
            <Button
              type="success"
              @click.prevent="onExportExcel"
              :loading="exporting"
            >
              <i class="fas fa-file-excel"></i> {{ $t('export') }}
            </Button>
          </div>
          <div class="col-md-6">
            <div class="d-flex justify-content-end">
              <div class="d-flex ts-space-x-3">
                <a-select
                  v-model="location_id"
                  :maxTagCount="1"
                  mode="multiple"
                  :placeholder="$t('all')"
                  style="width: 300px"
                  @change="fetchData()"
                  :options="warehouse"
                >
                </a-select>
                <a-select
                  v-model="sn_status_id"
                  :maxTagCount="1"
                  mode="multiple"
                  :placeholder="$t('all')"
                  style="width: 200px"
                  @change="fetchData()"
                >
                  <a-select-option
                    v-for="(s, index) in serialStatus"
                    :key="index"
                    :value="s.sn_status_id"
                  >
                    {{ s.sn_status }}
                  </a-select-option>
                </a-select>
                <ts-input
                  v-tooltip="
                    company_id == 1
                      ? $t('productProfile.searchSerialCow')
                      : $t('productProfile.searchSerialCar')
                  "
                  v-model="search.text"
                  :placeholder="$t('search')"
                  style="width: 250px"
                  class="inline-block"
                />
              </div>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-loading-banner :loading="loading">
        <CowSerialTable
          v-if="company_id == 1"
          :serial-resources="serialResources"
          :fetchData="fetchData"
          :model="model"
        >
        </CowSerialTable>
        <CarSerialTable
          v-else
          :serial-resources="serialResources"
          :fetchData="fetchData"
          :model="model"
           @refresh-data="fetchData"
        >
        </CarSerialTable>
        <div class="d-flex justify-content-end ts-overflow-x-scroll ts-mt-3">
          <ts-pagination
            v-model="serialPagination"
            @navigate="fetchData"
          ></ts-pagination>
        </div>
        <a-modal
          :title="$t('pdf')"
          width="500px"
          v-model="show_pdf"
          :footer="null"
          @cancel="fetchData()"
        >
          <ts-preview-pdf v-model="waiting_update" :src="src" />
        </a-modal>
      </ts-loading-banner>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import ViewSerialHistory from './components/view-serial-history.vue'
import UploadPhoto from './components/upload-photo.vue'
import CowUpdateSerial from './components/cow-update-serial.vue'
import CowSerialTable from './components/cow-serial-table.vue'
import CarSerialTable from './components/car-serial-table.vue'
import { trim } from 'lodash'
import * as FileDownload from 'downloadjs'
import moment from 'moment'

export default {
  name: 'productAllSerialList',
  components: {
    ViewSerialHistory,
    UploadPhoto,
    CowUpdateSerial,
    CowSerialTable,
    CarSerialTable
  },
  data() {
    return {
      src: null,
      show_pdf: false,
      loading: false,
      waiting_update: false,
      waiting: false,
      update_imei_loading: false,
      export_resource_loading: false,
      show_export_form: false,
      exporting: false,
      sn_status_id: [1],
      location_id: [],
      history: [],
      movementHistory: [],
      show_history_serial: false,
      show_modal_update_imei_serial: false,
      show_history_serial_waiting: false,
      show_upload_photo_waiting: false,
      show_upload_photo: false,
      errors: new Errors(),
      employees: [],
      employeeResources: [],
      search: {
        text: ''
      },
      copied: 'Click to copy serial',
      grades: [],
      model: {
        serial_no: '',
        imei: '',
        qc_remarks: '',
        qc_by: null,
        product_grade: '',
        cost: 0,
        weight: 0,
        color: '',
        sex: '',
        attach_file_list: [],
        plate_number: '',
        mc_number: '',
        year_of_m: 0,
        engine_number: '',
        steering_wheel: '',
        vehicle_registration_date: moment().format('DD-MM-YYYY'),
        issued_by: ''
      }
    }
  },

  computed: {
    company_id() {
      return this.$store.state.authUser.user.default_branch.company_id
    },
    ...mapState('product/profile', [
      'serialPagination',
      'serialStatus',
      'edit_data',
      'colors',
      'steeringWheels'
    ]),
    serialResources() {
      return this.$store.state.product.profile.serialResources.map(item => {
        return Object.assign(
          {
            allow_edit:
              (item.ref_stock_transfer_id || item.ref_write_off_id) &&
              item.sn_status_id <= 3
                ? false
                : true
          },
          item
        )
      })
    },
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
    isAllUploaded() {
      const allFiles = this.model.attach_file_list.length

      const uploadedFile = this.model.attach_file_list.filter(
        u => u.uploaded === true
      )

      return allFiles == uploadedFile.length
    },
    warehouse() {
      return this.$store.state.product.profile.warehouses.map(el => ({
        value: el.location_id,
        label: el.location_name_en,
        is_default: el.pivot.is_default
      }))
    }
  },
  created() {
    this.fetchWarehouseAssigned()
  },
  methods: {
    ...mapActions('product/profile', [
      'fetchSerialStatus',
      'fetchWarehouseAssigned',
      'fetchSerialHistory',
      'employee',
      'getColor',
      'getSteeringWheel',
      'formViewModel'
    ]),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/profile/fetchAllSerial', {
          sn_status_id: this.sn_status_id,
          location_id: this.location_id,
          filter: {
            search: this.search.text
          },
          ...attributes
        })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    fetchEmployee() {
      this.update_imei_loading = true
      this.employee()
        .then(async response => {
          this.employees = response.data
          await this.formViewModel({
            fnName: 'productGrade'
          }).then(({ data }) => {
            this.grades = data.productGrade
          })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.update_imei_loading = false
        })
    },
    handleSearchEmployee(value) {
      let em = this.employees.find(em => em.card_id == value)
      if (em) {
        this.model.qc_by = em.employee_id
      }
    },
    setDefaultWarehouse() {
      this.location_id.push(
        this.$store.state.authUser.user.warehouses.find(
          el => el.pivot.is_default == true
        ).location_id
      )
      this.fetchData()
    },
    fetchWarehouseAssigned() {
      this.$store
        .dispatch('product/profile/fetchWarehouseAssigned')
        .then(() => {
          this.setDefaultWarehouse()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    onExportExcel() {
      this.exporting = true
      this.error = new Errors()
      this.$store
        .dispatch('product/profile/exportExcel', {
          location_id: this.location_id,
          sn_status_id: this.sn_status_id
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
          this.show_export_form = false
          this.clearInput()
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.exporting = false
        })
    },
    onCopy: function(e) {
      this.copied = 'Copied'
      setTimeout(() => {
        this.copied = 'Click to copy serial'
      }, 1000)
    },
    onError: function(e) {
      this.copied = 'Failed Copied'
    }
  },
  watch: {
    'search.text': debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchSerialStatus()
      vm.getColor()
      vm.getSteeringWheel()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/profile/SET_RESET_SERIAL_PAGE')
    this.$store.commit('product/profile/RESET_RESOURCES_SERIAL')
    next()
  }
}
</script>
